module.exports = __webpack_public_path__ + "tiny_face_detector_model-shard1.shard";